const TeamMembers = [
  {
    name: "Justin Gordon",
    designation: "CEO",
    imageUrl: "Justin.jpg",
    show: true,
    linkedinLink: "https://www.linkedin.com/in/railsonmaui/",
  },
  {
    name: "Alex Fedoseev",
    designation: "Frontend Lead Architect",
    imageUrl: "Alex.jpg",
    show: true,
  },
  {
    name: "Sergey Tarasov",
    designation: "Backend Lead Architect",
    imageUrl: "Sergey.png",
    show: true,
  },
  {
    name: "Alexander Kharitonov",
    designation: "Senior Client Lead",
    imageUrl: "Sasha.jpg",
    show: true,
  },
  {
    name: "Igor Galvao",
    designation: "Senior Client Lead",
    imageUrl: "Igor.jpg",
    show: true,
  },
  {
    name: "Martin Zlámal",
    designation: "Senior Client Lead",
    imageUrl: "Martin.jpg",
    show: false,
  },
  {
    name: "Ben",
    designation: "HiChee Marketing",
    imageUrl: "Ben.png",
    show: false,
  },
  {
    name: "Manoela",
    designation: "Boss",
    imageUrl: "Manoela.jpg",
    show: false,
  },
  {
    name: "Ivan",
    designation: "Customer Success Advocate",
    imageUrl: "Ivan.png",
    show: false,
  },
  {
    name: "Eugene",
    designation: "Lead Designer",
    imageUrl: "Eugene.png",
    show: false,
  },
  {
    name: "Gustavo",
    designation: "Lead Developer",
    imageUrl: "Gustavo.png",
    show: false,
  },
  {
    name: "Gabriella",
    designation: "Office Manager",
    imageUrl: "Gabriella.jpg",
    show: false,
  },
  {
    name: "Anton",
    designation: "Senior Developer",
    imageUrl: "Anton.png",
    show: false,
  },
  {
    name: "Akansha",
    designation: "Developer",
    imageUrl: "Akansha.png",
    show: false,
  },
  {
    name: "Renan",
    designation: "Senior Developer",
    imageUrl: "Renan.png",
    show: false,
  },
  {
    name: "Judah",
    designation: "Senior Developer",
    imageUrl: "Judah.jpg",
    show: false,
  },
  {
    name: "Hussain",
    designation: "Senior Developer",
    imageUrl: "Hussain.png",
    show: false,
  },
  {
    name: "Andrey",
    designation: "Senior Developer",
    imageUrl: "Andrey.png",
    show: false,
  },
  {
    name: "Roman",
    designation: "Senior Developer",
    imageUrl: "Roman.jpg",
    show: false,
  },
  {
    name: "Gonzalo",
    designation: "Senior Developer",
    imageUrl: "Gonzalo.png",
    show: false,
  },
  {
    name: "Pulkit",
    designation: "Senior Developer",
    imageUrl: "Pulkit.png",
    show: false,
  },
  {
    name: "Mikhail ",
    designation: "Senior Developer",
    imageUrl: "Mikhail.png",
    show: false,
  },
  {
    name: "Rob",
    designation: "Software Developer",
    imageUrl: "Rob.png",
    show: false,
  },
  {
    name: "Alexey",
    designation: "Software Developer",
    imageUrl: "Alexey.jpeg",
    show: false,
  },
  {
    name: "Alkesh Ghorpade",
    designation: "Senior Software Developer",
    imageUrl: "Alkesh.jpeg",
    show: false,
  },
  {
    name: "Mostafa Ahangarha",
    description: "Software Developer",
    imageUrl: "Ahangarha.jpg",
    show: false
  },
  {
    name: "Samuel de Moura",
    designation: "Senior Software Developer",
    imageUrl: "Samuel.jpg",
    show: false
  }
]

export default TeamMembers
